/*
 * @Author: lipengcheng
 * @Date: 2023-05-24 13:37:01
 * @LastEditTime: 2023-05-25 10:40:23
 * @Description:
 */
export default {
  state: {
    menuList: [],
    btnData: {},
    currentMenusID: '',
  },
  mutations: {
    setMenuList(state, list) {
      console.log(list);
      state.menuList = list;
    },
    setBtnData(state, data) {
      state.btnData = data;
    },
    setCurrentMenusID(state, id) {
      state.currentMenusID = id;
    },
  },
  actions: {

  },
};
